module.exports = __webpack_public_path__ + "img/throwDropText2.c979b64e.png";